import { getMediaLink } from "@/utils/mediaLink";

import * as S from "./styled";

interface PropertyPhotoProps {
  readonly photoUrl?: string;
}

export default function PropertyPhoto({ photoUrl }: PropertyPhotoProps) {
  const photo = getMediaLink({ link: photoUrl });
  return <S.PropertyPhoto $photo={photo} src={photo} data-testid="property-photo"></S.PropertyPhoto>;
}
